import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN,
  getAdminEmpresa,
  getFinanceiroAgencia,
  getGestorEmpresa,
  getOperadorEmpresa,
  getPerfisVendedores, getFinanceiroCaixa,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';

export class MenuFechamentoCaixa extends Component {
  render () {
    return (
      <div className="area-home">
        <Titulo texto="Fechamento de Caixa" urlRetorno="/"/>
        <div className="vx-quick-actions mt-3">
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <Link to="/painel-fechamento-caixa" className="vx-action-card">
              <div className="vx-action-icon-wrap c-orange">
                <AddCardOutlinedIcon />
              </div>
              <div>
                <p className="vx-action-title">Fechamento por Usuário</p>
                <p className="vx-action-desc">
                  <span className="material-icons">person</span>
                  Consultar e aprovar fechamentos de caixa por agente
                </p>
              </div>
            </Link>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <Link to="/painel-fechamento-caixa-agencia" className="vx-action-card">
              <div className="vx-action-icon-wrap c-teal">
                <AddBusinessOutlinedIcon />
              </div>
              <div>
                <p className="vx-action-title">Fechamento por Agência</p>
                <p className="vx-action-desc">
                  <span className="material-icons">store</span>
                  Consultar e aprovar fechamentos de caixa por agência
                </p>
              </div>
            </Link>
          </Autorizacao>
        </div>
      </div>
    );
  }
}
export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada ? state.empresaSelecionada : '',
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuFechamentoCaixa));
